import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LocalStorageRefService } from './local-storage-ref.service';

interface LocalStorageInfoType {
  whatsNewVersion: string;
}

@Injectable()
export class GlobalSettingsService {

  private fuelTypeSubject$ = new BehaviorSubject('100LL');
  fuelType = this.fuelTypeSubject$.asObservable();

  private _localStorage: Storage;
  private _LocalStorageInfo$ = new BehaviorSubject<LocalStorageInfoType>(null);
  localStorageInfo$ = this._LocalStorageInfo$.asObservable();

  constructor(private _localStorageRefService: LocalStorageRefService) {
    this._localStorage = _localStorageRefService.localStorage;
  }

  changeFuelType(fuel: string) {
    this.fuelTypeSubject$.next(fuel);
  }

  setInfo(data: LocalStorageInfoType) {
    const jsonData = JSON.stringify(data);
    this._localStorage.setItem('airportsAndDest', jsonData);
    this._LocalStorageInfo$.next(data);
  }

  loadInfo() {
    const data = JSON.parse(this._localStorage.getItem('airportsAndDest'));
    this._LocalStorageInfo$.next(data);
  }

  clearInfo() {
    this._localStorage.removeItem('airportsAndDest');
    this._LocalStorageInfo$.next(null);
  }

  clearAllLocalStorage() {
    this._localStorage.clear();
    this._LocalStorageInfo$.next(null);
  }
}
